import React from 'react';
import PrintComponent from '../Component/PrintComponent/PrintComponent';

function PrintPage(props) {
    return (
        <>
            <PrintComponent />
        </>
    );
}

export default PrintPage;